
import VectorTileSource from "ol/source/VectorTile";
import {MVT} from "ol/format";
import TileGrid from "ol/tilegrid/TileGrid";
import {getTopLeft} from "ol/extent";
import {applyStyle} from "ol-mapbox-style";
import {
    getLayerAttributes,
    getLayerNamePrefix,
    removeLayer,
    removeLoaderByBookmarkPresentationID
} from "@/helpers/ol/ol-layer-helper";
import VectorTileLayer from "ol/layer/VectorTile";
import {Projection, get as getProjection} from "ol/proj";
import {OGCVectorTile} from "ol/source";

import {getViewProjection, getViewProjectionByName} from "@/helpers/ol/ol-projection-helper";
import {scaleToResolution} from "@/helpers/ol/view/ol-view-resolutation-helper.js";
import {createXYZ} from "ol/tilegrid";
/**
 *
 * @param map
 * @param service
 */
export function addServiceMvt(map, service) {

    const projection = getViewProjectionByName(service.Service.Projection )

    let source
    if(service.Service.Projection === 'EPSG:28992') {
        source = new VectorTileSource({
            format: new MVT(),
            projection: getViewProjection(),
            url: service.Url,
            maxZoom: service.MaxZoom,
            attributions: getLayerAttributes(service),
        })
    } else {
        if(service.Url.includes('{z}')) {
            source = new VectorTileSource({
                attributions: getLayerAttributes(service),
                format: new MVT(),
                projection: projection,
                url: service.Url
            })
        } else {
            source = new OGCVectorTile({
                attributions: getLayerAttributes(service),
                format: new MVT(),
                projection: projection,
                url: service.Url
            })
        }
    }

    const layer = new VectorTileLayer({
        zIndex: service.zIndex,
        name: getLayerNamePrefix() + service.id,
        renderMode: 'hybrid',
        declutter: true,
        minResolution: scaleToResolution(service.MinResolution),
        maxResolution: scaleToResolution(service.MaxResolution),
        useInterimTilesOnError: false,
        source: source,
        opacity: service.Opacity / 10,
    })

    console.log(layer)

    let styleUrl = service.StyleActive
    if(styleUrl) {

        console.log('with style')

        fetch(styleUrl)
            .then(r => r.json())
            .then(style => applyStyle(layer, style))
            .then(() => {
                map.addLayer(layer);
            })
    } else {
        console.log('without style')
        map.addLayer(layer);
    }

    removeLoaderByBookmarkPresentationID(service.id)

    return layer
}

function getMatrixIdsVt (z = 9) {
    return Array(z + 1).fill().map((x, i) => i)
}
function getResolutionsVt (z = 9, number = 3440.64) {
    return getMatrixIdsVt(z).map(x => number / 2 ** (x))
}

export function removeInfoMvt() {
    removeLayer('mvt-info')
}
